import * as geom from "js/core/utilities/geom";
import { AssetType } from "common/constants";
import { CollectionElement, CollectionItemElement } from "js/elements/base/CollectionElement";
import { ContentElement } from "js/elements/base/ContentElement";

class LogoGrid extends CollectionElement {
    getChildItemType(itemModel) {
        return LogoGridItem;
    }

    get maxItemCount() {
        return 30;
    }

    _calcProps(props, options) {
        let { size, children, styles } = props;

        let layouter = this.getLayouter(this.itemElements, size).calcBoxGridLayout();

        return { size: layouter.size };
    }
}

class LogoGridItem extends CollectionItemElement {
    static get schema() {
        return {
            backgroundColor: "white"
        };
    }

    get selectionPadding() {
        return 0;
    }

    _build() {
        this.logo = this.addElement("logo", () => ContentElement, {
            defaultAssetType: AssetType.LOGO
        });
    }

    _calcProps(props, options) {
        let { size, children, styles } = props;

        // if (!this.parentElement.model.showFrame) {
        //     this.decoration.styles.strokeWidth = 0;
        // }

        let frameColor = "white";
        if (this.logo.assetElement && this.logo.assetElement.hasAlpha) {
            frameColor = this.model.backgroundColor;
        }

        this.createDecoration({
            type: "frame",
            shape: "rect",
            fillColor: frameColor,
            strokeColor: "secondary_dark 0.1",
            strokeWidth: this.parentElement.model.showFrame ? 1 : 0
        });

        let logoProps = children.setProps(this.logo, size);
        logoProps.bounds = new geom.Rect(0, 0, size);

        return { size };
    }
}

export const elements = {
    LogoGrid
};
